// extracted by mini-css-extract-plugin
export default {"inpfield":"contactFormService_inpfield__jJFOe","heading":"contactFormService_heading__jTV2Q","btn":"contactFormService_btn__mFDmn","formLabel":"contactFormService_formLabel__xRH-N"};